export function randomKey() {
    return 500000 + Math.floor(Math.random() * (1000000 + 1 - 500000));
}
